<template>
<div class="FaultRecordContainer">
  <div class="query newDate">
    <span>
      <el-date-picker v-model="creatTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
      </el-date-picker>
      <el-select v-model="faultStatus" placeholder="故障状态" clearable>
        <el-option v-for="item in faultStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <!-- <el-input placeholder="请输入故障内容" v-model="content" style="width:170px;"></el-input> -->
      <button class="primaryBtn" @click="serachData">查询</button>
    </span>
  </div>
  <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="alarmCurrentChange" @sizeChange="alarmSizeChange">
    <el-table-column type="index" width="50" label="#" border></el-table-column>
    <el-table-column prop="status" label="状态" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="name" label="设备名称" :show-overflow-tooltip="true"></el-table-column>
    <!-- <el-table-column prop="id" label="ID" :show-overflow-tooltip="true"></el-table-column> -->
    <el-table-column prop="imei" label="IMEI" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="installLocation" label="设备安装位置" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="content" label="故障内容" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="createTime" label="故障时间" :show-overflow-tooltip="true"></el-table-column>
  </border-table>
</div>
</template>

<script>
import BorderTable from "@/views/deviceManagement/deviceDetails/BorderTable";
export default {
  components: {
    BorderTable
  },
  props: {
    deviceChildId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    type: {
      type: String,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      fbdate: null,
      fedate: null,
      creatTime: [],
      pickerOptions: {
        shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dealDialogPar: {
        show: false,
        row: {}
      },
      handleState: '',
      params: {},
      paramdata: '',
      content: '',
      drawerShow: false,
      drawerShowHandle: false,
      drawerTitle: '',
      selectData: {},
      drawerWidth: '500px',
      loading: false,
      typeOptions: [],
      faultStatus: '',
      faultStatusOptions: [
        {
          value:'传感器故障',
          label: '传感器故障'
        },
        {
          value: 'KBG内部通讯错误',
          label: 'KBG内部通讯错误'
        },
        {
          value: '无线模块通信错误',
          label: '无线模块通信错误'
        },
        {
          value: '设备未知异常',
          label: '设备未知异常'
        }
      ]
    }
  },
  created() {
    this.makeheight()
    this.reloadTable()
  },
  methods: {
    serachData() {
      //查询//查询
      this.content = this.content.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    alarmCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloadTable();
    },
    //表格展示条数变化时
    alarmSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    dealDialog(row) {
      this.$confirm('此操作将处理故障, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dealDialogPar.show = true
        this.dealDialogPar.row = row
      }).catch(() => {
        this.msg.info('已取消处理')
      });
    },
    // 版权 获取当前年
    getCurrentYear() {
      let type = this.type ?? 'gateway'
      if (this.creatTime != null && this.creatTime.length) {
        let date = new Date();
        let y = date.getFullYear();

        let date0 = this.creatTime[0];
        let y0 = date0.getFullYear();

        let date1 = this.creatTime[1];
        let y1 = date1.getFullYear();

        let date2 = this.creatTime[0];
        let y2 = this.formatDate(date2)
        let data3 = this.formatterDate(this.storage.getSession("sysStartTime"));
        let y3 = this.formatDate(data3)

        if (y0 > y) {
          this.msg.error('输入开始日期年份大于当前年份，请重新输入！')
        } else if (y1 > y) {
          this.msg.error('输入结束日期年份大于当前年份，请重新输入！')
        } else if (y3 > y2) {
          this.msg.error('选择时间小于系统开始时间，请重新输入！')
        } else {
          this.tableLoading = true
          this.fbdate = this.formatDate(this.creatTime[0]);
          this.fedate = this.formatDate(this.creatTime[1]);
          this.params = {
            "key": this.content,
            "startTime": this.fbdate,
            "endTime": this.fedate,
            "status": this.faultStatus,
            "deviceId": this.deviceChildId,
            "page": this.pagination.currentPage,
            "pageSize": this.pagination.pageSize,
            "sort": "createTime",
            "order": "desc"
          }

          this.request.get(`/front/device/${type}/child/fault`, this.params).then(res => {
            if (res.code == 200) {
              this.tableLoading = false
              this.dataList = res.data;
              this.pagination.total = res.total;
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
              // this.msg.warn("查询月份的报警分表不存在")
            }
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        // this.msg.warn("请选择开始日期和结束日期！")
        this.params = {
          "key": this.content,
          "startTime": '',
          "endTime": '',
          "status": this.faultStatus,
          "deviceId": this.deviceChildId,
          "page": this.pagination.currentPage,
          "pageSize": this.pagination.pageSize,
          "sort": "createTime",
          "order": "desc"
        }
        this.request.get(`/front/device/${type}/child/fault`, this.params).then(res => {
          if (res.code == 200) {
            this.tableLoading = false
            this.dataList = res.data;
            this.pagination.total = res.total;
          } else if (res.code == 500) {
            // this.msg.warn("查询月份的报警分表不存在")
            this.msg.warn(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    reloadTable() {
      this.getCurrentYear()
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
      return times;
    },
    formatterDate(date) {
      let result = new Date(date);
      return result;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    }
  }
}
</script>

<style lang="scss">
.FaultRecordContainer {
  .query {
    padding-bottom: 15px;

    .primaryBtn {
      width: 82px;
      height: 36px;
      cursor: pointer;
      margin-right: 20px;
      font-size: 14px;
      line-height: 36px;
      border: 0;
      color: #FFFFFF;
      background: #1089FF;
      border-radius: 2px;

      &:hover {
        background: #0774e0;
      }
    }

    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }

  .newDate {

    .el-date-editor--datetimerange.el-input,
    .el-date-editor--datetimerange.el-input__inner {
      width: 380px;
    }
  }
}

.exportBtn {
  background: #1089FF;
  color: #fff;
  padding: 11px 15px;
  height: 36px;
  line-height: 36px;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
}
</style>
